export interface ILogisticsState {
    [key: string]: string | boolean,

    logisticsProvider: string,
    jobNumber: string,
    donorSurgeonContactId: string,
    recipientSurgeonContactId: string,

    donorCoordinator: string,
    recipientCoordinator: string,
    
    kidneyPickupDateTime: string,
    kidneyPickupDateTimeValid: boolean,
    kidneyPickupDateTimeBackup: string,
    kidneyPickupDateTimeBackupValid: boolean,
    kidneyPickupDateTimeActual: string,
    kidneyPickupDateTimeActualValid: boolean,
    kidneyPickupDateTimeTz:string,

    pickupGroundMiles: string,
    pickupGroundMilesBackup: string,
    pickupGroundMilesActual: string,

    flightRouteOrGround: string,
    flightRouteOrGroundBackup: string,
    flightRouteOrGroundActual: string,

    dropoffGroundMiles: string,
    dropoffGroundMilesBackup: string,
    dropoffGroundMilesActual: string,

    kidneyArrivalDateTime: string,
    kidneyArrivalDateTimeValid: boolean,
    kidneyArrivalDateTimeBackup: string,
    kidneyArrivalDateTimeBackupValid: boolean,
    kidneyArrivalDateTimeActual: string,
    kidneyArrivalDateTimeActualValid: boolean,
    kidneyArrivalDateTimeTz:string,

    transportMethod: string,
    transportMethodBackup: string,
    transportMethodActual: string,

    transportCost: string,
    transportCostBackup: string,
    transportCostActual: string,

    courierTransportCost: string,
    courierTransportCostBackup: string,

    flightCarrierAndNumber: string,
    flightCarrierAndNumberBackup: string,
    flightCarrierAndNumberActual: string,

    flightDepartureTime: string,
    flightDepartureTimeTz: string,
    flightDepartureTimeValid: boolean,
    flightDepartureTimeBackup: string,
    flightDepartureTimeBackupTz: string,
    flightDepartureTimeBackupValid: boolean,
    flightDepartureTimeActual: string,
    flightDepartureTimeActualTz: string,
    flightDepartureTimeActualValid: boolean,

    flightArrivalTime: string,
    flightArrivalTimeTz: string,
    flightArrivalTimeValid: boolean,
    flightArrivalTimeBackup: string,
    flightArrivalTimeBackupTz: string,
    flightArrivalTimeBackupValid: boolean,
    flightArrivalTimeActual: string,
    flightArrivalTimeActualTz: string,
    flightArrivalTimeActualValid: boolean,

    tenderedToAirlineActual: string,
    tenderedToAirlineActualTz: string,
    tenderedToAirlineActualValid: boolean,
    recoveredFromAirlineActual: string,
    recoveredFromAirlineActualTz: string,
    recoveredFromAirlineActualValid: boolean,

    leg2DepartureTime: string,
    leg2DepartureTimeTz: string,
    leg2DepartureTimeValid: boolean,
    leg2DepartureTimeBackup: string,
    leg2DepartureTimeBackupTz: string,
    leg2DepartureTimeBackupValid: boolean,
    leg2DepartureTimeActual: string,
    leg2DepartureTimeActualTz: string,
    leg2DepartureTimeActualValid: boolean,

    leg2ArrivalTime: string,
    leg2ArrivalTimeTz: string,
    leg2ArrivalTimeValid: boolean,
    leg2ArrivalTimeBackup: string,
    leg2ArrivalTimeBackupTz: string,
    leg2ArrivalTimeBackupValid: boolean,
    leg2ArrivalTimeActual: string,
    leg2ArrivalTimeActualTz: string,
    leg2ArrivalTimeActualValid: boolean,

    deliveryLocation: string,
    deliveredTo: string,

    activeLogisticsPlan: string,

    notes: string
}